import { SliderModal } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { Box } from 'native-base';
import React, { useCallback } from 'react';
import { ScrollView } from 'react-native';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../../../../../routes/types';

export namespace PrivatePensionModalContainerTypes {
  export interface Props {
    children: React.ReactNode;
    /**
     * @default true
     */
    dismissable?: boolean;
  }
}

export const PrivatePensionModalContainer: React.FC<PrivatePensionModalContainerTypes.Props> = ({
  children,
  dismissable = true,
}) => {
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();

  const responsiveWidth = useBreakpointValue({
    base: 1,
    sm: 1,
    md: 0.42,
  });

  const handleGoBack = useCallback(() => {
    if (!dismissable) {
      return;
    }

    navigation.goBack();
  }, [dismissable, navigation]);

  return (
    <SliderModal width={responsiveWidth} onDismiss={handleGoBack}>
      <ScrollView style={{ flex: 1 }}>
        <Box flex={1} padding="inset.sm">
          {children}
        </Box>
      </ScrollView>
    </SliderModal>
  );
};
